import { useSavedCommoditiesApi } from "@/Hooks/useSavedCommoditiesApi";
import type { UUID } from "@/Shared/types";
import type {
  AddSavedCommodityRequest,
  DeleteSavedCommodityRequest,
  ModifySavedCommodityRequest,
} from "@freightsimple/generated-dashboard-openapi-client/apis/SavedCommoditiesApi";
import type { SavedCommodity } from "@freightsimple/generated-dashboard-openapi-client/models/SavedCommodity";

export function useSavedCommoditiesService() {
  const savedCommoditiesApi = useSavedCommoditiesApi();

  return {
    addSavedCommodity: async function (savedCommodity: SavedCommodity) {
      const request: AddSavedCommodityRequest = {
        savedCommodity,
      };

      await savedCommoditiesApi.addSavedCommodity(request);
    },

    modifySavedCommodity: async function (savedCommodity: SavedCommodity) {
      const request: ModifySavedCommodityRequest = {
        savedCommodity,
      };

      await savedCommoditiesApi.modifySavedCommodity(request);
    },

    deleteSavedCommodity: async function (savedCommodityId: UUID) {
      const request: DeleteSavedCommodityRequest = {
        savedCommodityId,
      };
      await savedCommoditiesApi.deleteSavedCommodity(request);
    },

    getAllSavedCommodities: async function () {
      return savedCommoditiesApi.getAllSavedCommodities();
    },

    syncFromShopify: async function () {
      return savedCommoditiesApi.syncSavedCommoditiesFromShopify();
    },

    getShopifySyncStatus: async function () {
      return savedCommoditiesApi.getShopifyCommoditySyncStatus();
    },
  };
}
